import VueCookies from 'vue-cookies'
// 公共登录 设置cookid 
export const setLogin = (data) => {
    return new Promise((resolve) => {
        // console.log(1, data);
        VueCookies.set('ACCESS_TOKEN', data.accessToken, '0'); //有效期0 session存储
        VueCookies.set('REFRESH_TOKEN', data.refreshToken, '0');
        resolve()
    })
}
// 公共登出
export const setLoginOut = () => {
    // console.log(2, data);
    VueCookies.remove("ACCESS_TOKEN");
    VueCookies.remove("REFRESH_TOKEN");
    VueCookies.remove("SHOPLOGIN");
}